<div class="ax-toolbar-menu-container">
    <ax-menu #menu [items]="items" [selection]="selection" (itemClick)="onItemClick($event)" [menuTemplate]="menuTemplate">
    </ax-menu>
</div>